import React from "react"
import LoanPayoff from "activities/calculators/early-payoff"
import merge from "lodash/merge"

export default (props) => (
  <LoanPayoff
    {...merge(
      {
        id: "auto-loan",
        title: "Auto Loan Calculator",
        subtitle: "Explore what it would take to pay off your auto loan early.",
        amountTitle: "Vehicle Price",
        downPayment: {
          show: true,
          step: 50
        },
        loanTerm: {
          min: 1,
          max: 8,
          step: 1
        },
        interestRate: {
          min: 0,
          max: 20,
          step: 0.01
        },
        addedPayment: {
          min: 0,
          max: (payment) => Math.floor((payment * 3) / 100) * 100,
          step: 20
        },
        initialState: {
          price: 30000,
          payment: 1000,
          years: 5,
          rate: 4,
          term: 5,
          additionalPayment: 100
        },
        ariaLabel:
          "This line graph visually represents how much sooner you could pay off your auto loan. Read below to find the monthly payment, interest saved, interest to be paid, and the date the auto loan will be paid off."
      },
      props
    )}
  />
)
